<template>
  <div id="intention-the-product">
    <!-- 选择意向产品 -->
    <div class="intention-the-product-line">
      <div class="intention-the-product-line-title">客户名称:</div>
      <div class="intention-the-product-line-value">{{ value.clientName }}</div>
    </div>

    <div class="intention-the-product-line">
      <div class="intention-the-product-line-title">已选产品:</div>
      <div class="intention-the-product-line-value"></div>
    </div>
    <div class="intention-the-product-choose">
      <div
        class="div-border"
        v-for="(item, index) in value.chooseProduct"
        :key="index"
        @click="choseProductTipOne(item, index, 0)"
      >
        {{ item.title }}
      </div>
    </div>
    <div class="intention-the-product-line">
      <div class="intention-the-product-line-title">请先选择服务类型:</div>
      <div class="intention-the-product-line-value">
        <el-select
          v-model="serviceType"
          placeholder="请选择"
          filterable
          value-key="id"
          @change="changeServiceType"
          popper-append-to-body
        >
          <el-option
            v-for="item in serviceTtypeOptions"
            :key="item.id"
            :label="item.typeName"
            :value="item"
          >
          </el-option>
        </el-select>
      </div>
    </div>

    <div class="intention-the-product-choose">
      <div
        class="div-border"
        v-for="(item, index) in productList"
        :key="index"
        @click="choseProductTipOne(item, index, 1)"
      >
        {{ item.name }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["newContract"],
  data() {
    return {
      baseInfo: {},
      value: this.newContract,
      //   value: {
      //     clientName: "",
      //     chooseProduct:[]
      //   },
      serviceType: {},
      serviceTtypeOptions: [],
      productList: [{ id: "", name: "ttt" }],
    };
  },
  watch: {
    newContract() {
      //父组件值变化->>子组件也变化
      this.value = this.newContract;
    },
    value(newvalue) {
      //上一步的子组件(data)变化 提交给父组件事件 进行页面数据的更新
      this.$emit("show", newvalue);
    },
  },
  methods: {
    /**
     * 选择服务类别,显示具体合同模板
     */
    changeServiceType(val) {
      let requestData = {
        companyId: this.baseInfo.company.companyId,
        serviceId: val.id,
      };
      this.$request(
        "post",
        "/product/getAllProductByServiceType",
        requestData,
        (data) => {
          this.productList = data;
        },
        (errorMessage) => {
          this.$message.error(errorMessage);
        }
      );
    },
    /**
     * 选择合同模板单击事件
     */
    choseProductTipOne(data, index, flag) {
      switch (flag) {
        case 0:
          // 在已选产品中的点击事件
          this.value.chooseProduct.splice(index, 1);
          break;
        case 1:
          // 在未选产品中的点击事件
          let f = false;
          this.value.chooseProduct.forEach((element) => {
            if (element.id == data.id) {
              f = true;
              return;
            }
          });
          if (!f) {
            let dd = {
              id: data.id,
              title: data.name,
              serve: data.servicesItem,
            };
            this.value.chooseProduct.push(dd);
          }
          break;

        default:
          break;
      }
      console.log("意向产品的单击事件:", data);
      // this.$emit("choseProductTipOne", data);
    },
  },
  mounted() {
    this.baseInfo = JSON.parse(sessionStorage.getItem("userData"));
    let requestData = {
      companyId: this.baseInfo.company.companyId,
    };
    this.$request(
      "post",
      "/serveType/getAllServeType",
      requestData,
      (data) => {
        this.serviceTtypeOptions = data;
        if (data.length > 0) {
          this.serviceType = data[0];
          this.changeServiceType(data[0]);
        }
      },
      (errorMessage) => {
        this.$message.error(errorMessage);
      }
    );
  },
};
</script>

<style lang="less" scoped>
#intention-the-product {
  width: 100%;
  height: 500px;
  max-height: 500px;
  display: flex;
  flex-direction: column;
  .intention-the-product-line {
    width: 100%;
    height: 40px;
    display: flex;
    align-items: center;
    font-size: 12px;
    .intention-the-product-line-title {
      width: 20%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      margin-right: 5px;
    }
    .intention-the-product-line-value {
      flex: 1;
      height: 100%;
      width: 0;
      display: flex;
      align-items: center;
    }
  }

  .intention-the-product-choose {
    width: 100%;
    height: 0;
    flex: 1;
    overflow-y: auto;
    display: flex;
    flex-wrap: wrap;
    // flex-flow: row wrap;
    align-content: flex-start;
    &::-webkit-scrollbar {
      width: 1px;
    }
    .div-border {
      width: 170px;
      height: 100px;
      box-sizing: border-box;
      border: 1px solid @boderColor;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 14px;
      margin: 5px;
      transition: 0.3s;
      &:hover {
        background-color: @editGrayColor;
        color: @activeColor;
        cursor: pointer;
        border-color: @activeColor3;
      }
    }
  }
  .select-box span:focus-within {
    border: none;
    outline: none;
  }
}
</style>